import { useState } from 'react'
import { Link, NavLink } from 'react-router-dom'
import { clsx } from 'clsx'
import { Brand } from './Brand'
import { AuthModal } from './AuthModal'
import { useAuth } from '../store/auth'

const LINKS = [
  { to: '/gallery', label: 'Gallery' },
  { to: '/tiles', label: 'Tiles' },
  { to: '/play', label: 'Goon' },
  { to: '/memory', label: 'Memory' },
  { to: '/scoreboard', label: 'Leaderboard' },
  { to: '/profile', label: 'Profile' },
]

export function Nav() {
  const user = useAuth((s) => s.user)
  const isAdmin = useAuth((s) => s.isAdmin)
  const logout = useAuth((s) => s.logout)
  const [authOpen, setAuthOpen] = useState(false)

  return (
    <header className="sticky top-0 z-30 border-b border-edge/80 bg-ink/95 backdrop-blur-md shadow-[0_4px_24px_rgba(0,0,0,0.5)]">
      <nav className="mx-auto flex max-w-6xl items-center gap-2 px-3 py-2.5">
        <Link to="/" className="shrink-0">
          <Brand size="sm" />
        </Link>
        <div className="flex flex-1 items-center justify-center gap-0.5 overflow-x-auto">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              className={({ isActive }) =>
                clsx(
                  'whitespace-nowrap rounded-md px-2.5 py-1 font-comic text-base uppercase tracking-wide transition sm:px-3 sm:text-lg',
                  isActive
                    ? 'text-pow underline decoration-pow decoration-2 underline-offset-4 shadow-[0_0_12px_rgba(255,45,155,0.3)]'
                    : 'text-white/70 hover:text-white',
                )
              }
            >
              {l.label}
            </NavLink>
          ))}
          {isAdmin ? (
            <NavLink
              to="/admin"
              className={({ isActive }) =>
                clsx(
                  'whitespace-nowrap rounded-md px-2 py-1 font-comic text-sm uppercase tracking-wide transition',
                  isActive ? 'text-zap' : 'text-zap/60 hover:text-zap',
                )
              }
            >
              Admin
            </NavLink>
          ) : null}
        </div>
        {user ? (
          <div className="flex shrink-0 items-center gap-2">
            <span className="hidden max-w-[120px] truncate text-xs text-[#e7e7f2] sm:inline">
              {user.displayName ?? (user.handle ? `@${user.handle}` : 'gooner')}
            </span>
            <button
              onClick={() => logout()}
              className="rounded-md border border-edge px-2 py-1 text-xs font-bold uppercase text-muted transition hover:border-kapow hover:text-white"
            >
              Out
            </button>
          </div>
        ) : (
          <button onClick={() => setAuthOpen(true)} className="btn-comic shrink-0 px-3 py-1 text-sm sm:text-base">
            Sign in
          </button>
        )}
      </nav>
      <AuthModal open={authOpen} onClose={() => setAuthOpen(false)} />
    </header>
  )
}